import { render, staticRenderFns } from "./formfooter.vue?vue&type=template&id=141e9860&"
import script from "./formfooter.vue?vue&type=script&lang=js&"
export * from "./formfooter.vue?vue&type=script&lang=js&"
import style0 from "./formfooter.vue?vue&type=style&index=0&id=141e9860&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports